module.exports = __webpack_public_path__ + "static/img/变位内齿轮和正齿轮的计算.fabaf983.jpg";